// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.meteolanternaDebugSearch = {
    attach: function (context) {
      $(once('search-debug', 'input.form-autocomplete', context)).on('autocompleteselect', function (event, ui) {
        console.log('Elemento selezionato:', ui.item); // Questo apparir� in F12

        // Tentativo 1: URL diretto (Live Results)
        if (ui.item.url) {
          window.location.href = ui.item.url;
          return false;
        }

        // Tentativo 2: Estrazione URL da label HTML
        var htmlContent = ui.item.label || ui.item.value;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = htmlContent;
        var link = wrapper.querySelector('a');
        
        if (link && link.getAttribute('href')) {
          window.location.href = link.getAttribute('href');
          return false;
        }

        // Se nulla funziona, invia il form dopo un breve delay
        var $form = $(this).closest('form');
        setTimeout(function() {
          $form.submit();
        }, 100);
      });
    }
  };
})(jQuery, Drupal, once);